import { render, staticRenderFns } from "./profile-media.vue?vue&type=template&id=0daf85f8&"
import script from "./profile-media.vue?vue&type=script&lang=js&"
export * from "./profile-media.vue?vue&type=script&lang=js&"
import style0 from "./profile-media.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0daf85f8')) {
      api.createRecord('0daf85f8', component.options)
    } else {
      api.reload('0daf85f8', component.options)
    }
    module.hot.accept("./profile-media.vue?vue&type=template&id=0daf85f8&", function () {
      api.rerender('0daf85f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/account/profile/media/profile-media.vue"
export default component.exports